import moment from 'moment'

if (moment.tz) {
  console.log('__moment_initialization__', moment.tz.guess())
  moment.tz.setDefault(moment.tz.guess())
}

moment.updateLocale('en', {
  relativeTime: {
    past: '%s',
    s: 'just now',
    ss: 'just now',
    m: 'min', // a minute ago
    mm: '%d mins', // minutes ago
    h: 'h', // an hour ago
    hh: (number, withoutSuffix, key, isFuture) => {
      return number > 15 ? 'yesterday' : `${number} hours ago`
    },
    d: 'yesterday',
    dd: '%dd', // days ago - removed based on v1.8 design
    M: 'month', // a month ago
    MM: '%d months', // months ago
    y: 'year', // a year ago
    yy: '%d years', // years ago
  },
})
